<template>
    <div class="order-manage">
        <div class="top">
            <div class="operating-data">
                <div class="title-box">
                    <div class="title">经营数据</div>
                    <div class="filter-box">
                        <div :class="['filter-item',{active:stat_status == 'today'}]" @click="onChangeStatFilter('today')">
                            今天
                        </div>
                        <div :class="['filter-item',{active:stat_status == 'yesterday'}]" @click="onChangeStatFilter('yesterday')">
                            近1天
                        </div>
                        <div :class="['filter-item',{active:stat_status == 'week'}]" @click="onChangeStatFilter('week')">
                            近7天
                        </div>
                        <div :class="['filter-item',{active:stat_status == 'month'}]" @click="onChangeStatFilter('month')">
                            近30天
                        </div>
                    </div>
                </div>
                <div class="data-box">
                    <div class="today-box" v-show="stat_status=='today'">
                        <div class="today-data-items">
                            <div class="item-title">今日订单</div>
                            <div class="item-count">{{statistics.order_count}}</div>
                            <div v-if="false" class="item-desc">较昨日新增88单</div>
                        </div>
                        <div class="line"></div>
                        <div class="today-data-items">
                            <div class="item-title">成交金额</div>
                            <div class="item-count">¥{{statistics.order_money|price_format}}</div>
                            <div v-if="false" class="item-desc">较昨日增长:888.88元</div>
                        </div>
                    </div>
                    <div class="order-count-box">
                        <div class="order-count-item">
                            <div class="item-title">待支付</div>
                            <div class="item-count">{{statistics.order_unpaid_count}}</div>
                        </div>
                        <div class="order-count-item">
                            <div class="item-title">待发货</div>
                            <div class="item-count">{{statistics.order_wait_delivery_count}}</div>
                        </div>
                        <div class="order-count-item">
                            <div class="item-title">待售后订单</div>
                            <div class="item-count">{{statistics.order_wait_service_count}}</div>
                        </div>
                    </div>
                    <div class="month-sale-count">
                        <div class="item-title">本月销售额</div>
                        <div class="item-count">¥{{statistics.month_order_money|price_format}}</div>
                        <div v-if="false" class="item-desc">较上月同期减少了888.88元</div>
                    </div>
                </div>
            </div>
            <div class="shop-info">
                <div class="shop-owner-info">
                    <div class="info">
                        <img :src="shopInfo.logo|default_img" alt="" class="user-avatar" />
                        <div class="name-desc">
                            <div class="shop-name">{{shopInfo.shop_name}}</div>
                            <!-- {{shopInfo.shop_desc}} -->
                            <!-- <div class="shop-desc" :title="shopInfo.shop_desc" v-html="shopInfo.shop_desc"></div> -->
                            <div class="shop-desc">作品数 {{userInfo.works}} | {{ userInfo.fans_count||0 }} 人关注</div>
                        </div>
                    </div>
                    <div class="enter-shop" @click="onGoShop">进入店铺</div>
                </div>
                <div class="balance-count">
                    <div class="count-item">
                        <div class="item-title">可提现余额</div>
                        <div class="item-count">¥{{shopInfo.withdrawable_money|price_format}}</div>
                    </div>
                    <div class="count-item">
                        <div class="item-title">待结算余额</div>
                        <div class="item-count">¥{{shopInfo.shop_unsettle_money|price_format}}</div>
                    </div>
                    <div class="count-item">
                        <div class="item-title">店铺商品</div>
                        <div class="item-count">{{shopInfo.product_count || 0}}</div>
                    </div>
                </div>
                <div class="withdrawal-btn" @click="onShowAssetCenter">提现</div>
            </div>
        </div>
        <div class="order-list">
            <div class="order-list-top">
                <div class="order-list-title">订单列表</div>
                <div class="order-list-search">
                    <input type="text" v-model="query_form.keyword" placeholder="输入订单号搜索" @keyup.enter="onSearchOrder" />
                    <img src="@/assets/images/shop-manage/icon-shop-search.png" alt="" class="search-icon" @click="onSearchOrder" />
                </div>
            </div>
            <div class="order-filter-box">
                <div class="status-filter-box">
                    <div v-for="(item,index) in tab_list" :key="index" :class="['status-item',{active:query_form.status == item.value}]" @click="onChangeStatus(item)">{{ `${item.name}(${item.count})` }}</div>
                </div>
                <Poptip v-if="false" trigger="hover" placement="bottom">
                    <template #content>
                        <div>123123</div>
                    </template>
                    <div class="time-filter">
                        筛选 <Icon type="ios-arrow-down" />
                    </div>
                </Poptip>
            </div>
            <!-- 订单列表主体 -->
            <table v-if="query_form.status != 'in_service'">
                <thead>
                    <tr>
                        <th>商品信息</th>
                        <th>单价/数量</th>
                        <th>实收金额</th>
                        <!-- <th v-if="query_form.status == 'in_service'">售后状态</th> -->
                        <th v-if="['all','in_service'].includes(query_form.status)">订单状态</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <template v-if="list.length > 0">
                    <tbody v-for="(order,index) in list" :key="index" @click.stop="onDetailClick(order)">
                        <tr>
                            <!-- {{order.status_text}} -->
                            <td :colspan="['all'].includes(query_form.status) ? 5 : query_form.status == 'in_service' ? 6 : 4">
                                <div class="item-top">
                                    <div class="top-left">
                                        <span>订单编号 {{order.order_no}} <Icon type="ios-browsers-outline" class="cursor" @click.stop="onCopyOrderNo(order.order_no)" /></span>
                                        <span>下单时间 {{order.create_time}}</span>
                                        <span>买家: {{order.member.nickname || order.member.realname}}</span>
                                        <span v-if="userInfo.id !=  order.member.id" @click.stop="onChatClick(order.member)">
                                            <img src="@/assets/images/shop-manage/icon-shop-order-service.png" alt="" class="contact-icon" /> 联系买家
                                        </span>
                                    </div>
                                    <Poptip placement="top-end" trigger="hover" :disabled="!order.owner_memo" transfer>
                                        <template #content>
                                            <div>{{order.owner_memo}}</div>
                                        </template>
                                        <div class="top-right" @click.stop="showOrderRemark(order)">
                                            <img :src="order.owner_flag|remark_filter" alt="" class="remark-icon" /><span v-if="!order.owner_memo">添加备注</span>
                                        </div>
                                    </Poptip>
                                </div>
                            </td>
                        </tr>
                        <tr v-for="(item,oi) in order.goods" :key="oi">
                            <!-- 商品信息 -->
                            <td>
                                <div class="item-product-col" >
                                    <img :src="item.product_image|default_img" alt="" class="product-cover" />
                                    <div class="name-spec-box">
                                        <div class="name">{{item.product_name}}</div>
                                        <div class="spec">{{item.spec_info}}</div>
                                        <div class="restock-btn" @click.stop="onRestock(item)">补货</div>
                                    </div>
                                </div>
                            </td>
                            <!-- 单价/数量 -->
                            <td>
                                <div class="item-price-col">
                                    <span>¥{{item.price}}</span>
                                    <span>¥{{item.tag_price || 0}}</span>
                                    <span>x{{item.quantity}}</span>
                                </div>
                            </td>
                            <!-- 实收金额 -->
                            <td>
                                <div class="item-pay-price-col">
                                    <span>¥{{item.money}}</span>
                                    <!-- <span>含运费</span>
                                    <span>8.00</span> -->
                                </div>
                            </td>
                            <!-- 售后状态 -->
                            <!-- <td v-if="query_form.status === 'in_service'">
                                <div class="item-after-sale-col">
                                    <template v-if="index % 2 != 0">
                                        <div class="after-sale-type">
                                            <div class="label">售后类型:</div>
                                            <div class="value">退货退款</div>
                                        </div>
                                        <span>退货原因:款式与图片不符</span>
                                        <span>退款金额:¥888.88(-运费8元)</span>
                                        <div class="voucher-box">
                                            <img src="@/assets/images/shop-manage/icon-shop-order-voucher.png" alt="" class="voucher-icon" />
                                            查看凭证(2张)
                                        </div>
                                    </template>
                                    <div v-else class="empty">-</div>
                                </div>
                            </td> -->
                            <!-- 订单状态 -->
                            <td v-if="['all','in_service'].includes(query_form.status)" :rowspan="query_form.status == 'in_service' ? order.goods.length : 1">
                                <div class="item-order-status-col">
                                    <div class="order-status">
                                        <div :class="onGetStatusClass(order.status_text)">
                                            {{ order.status_name }} <span v-if="order.delivery_mode == 0">(工厂代发)</span>
                                        </div>
                                    </div>
                                    <Poptip placement="left" trigger="hover" :disabled="!order.logistics_no">
                                        <template #content>
                                            <div class="logistics-pop">
                                                <div class="pop-title">
                                                    <div class="title-left">
                                                        <div class="company-name">顺丰速运</div>
                                                        <div class="logistics-no">运单号：SF1069888888</div>
                                                    </div>
                                                    <div class="title-more">查看更多<Icon type="ios-arrow-forward" size="12" /></div>
                                                </div>
                                                <div class="pop-content">
                                                    <div class="content-item" v-for="(item,index) in 3" :key="index">
                                                        <div class="item-time">2026-08-08 08:08:08</div>
                                                        <div class="item-content">
                                                            <div v-if="index == 0" class="content-status">运输中</div>
                                                            <div class="content-desc">
                                                                [泉州市]您的快件离开[泉州市转运中心],已发往[丰泽转运中心]。预计[08月08日]到达[软件园店],因运输距离较远,预计将在[08日晚上]为您更新快件状态,请您放心!
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-if="order.logistics_no && order.status_delivery != 0" class="logistics">查询物流</div>
                                    </Poptip>
                                    <div v-if="false" class="apply-time">
                                        <span>申请时间</span>
                                        <span>2025-08-08 08:08</span>
                                    </div>
                                </div>
                            </td>
                            <!-- 操作 -->  
                              <!--v-show="query_form.status === 'in_service' ? oi == 0 :true"  -->
                            <td :rowspan="order.goods.length" v-show="oi==0">
                                <div class="item-operation-col">
                                    <div class="order-send" v-if="order.status_text === 'wait_delivery' && order.goods.some(item=>item.delivery_mode == 1)" @click.stop="onOrderShipped(order)">发货</div>
                                    <div v-if="order.status_text === 'wait_delivery' && order.goods.every(item=>Number(item.delivery_mode) === 0)" class="order-detail-btn">商品由平台发货</div>
                                    <!-- <div class="contact-service" v-if="order.delivery_mode == 0">联系工厂客服</div> -->
                                    <!-- <template v-if="order.status_text == 'in_service'">
                                        <div class="apply-order" @click="onApplyOrder(order)">审核通过</div>
                                        <div class="reject-order" @click="onRejectOrder(order)">驳回申请</div>
                                        <div class="confirm-recive" @click="onReciveOrder(order)">确认收货</div>
                                        <div class="fill-logistics-info" @click="onExchangeShipped(order)">填写发货信息</div>
                                        <div class="order-detail-btn" v-if="false">售后详情</div>
                                    </template> -->
                                    <div v-if="order.goods.length > 1 && order.goods.some(item=>item.delivery_mode != 1) && order.goods.some(item=>item.delivery_mode == 1)" class="order-detail-btn">
                                        部分商品平台发货
                                    </div>
                                    <div class="order-detail-btn" @click.stop="onDetailClick(order)">订单详情</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </template>
                <tbody v-else-if="list.length == 0 && !is_loading">
                    <tr>
                        <td :colspan="['all','in_service'].includes(query_form.status) ? 5 : 4" style="text-align:center;">暂无数据</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="['all','in_service'].includes(query_form.status) ? 5 : 4">
                            <Spin>
                                <Icon
                                type="ios-loading"
                                size="40"
                                class="spin-icon-load"
                                ></Icon>
                                <div>数据加载中...</div>
                            </Spin>
                        </td>
                    </tr>
                </tbody>
             </table>
             <table v-else>
                <thead>
                    <tr>
                        <th>商品信息</th>
                        <th>单价/数量</th>
                        <th>实收金额</th>
                        <th>售后状态</th>
                        <th>订单状态</th>
                        <th>操作</th>
                    </tr>
                </thead>
                <template v-if="list.length > 0">
                    <tbody v-for="(order,index) in list" :key="index" @click.stop="onServiceDetail(order)">
                        <tr>
                            <td :colspan="6">
                                <div class="item-top">
                                    <div class="top-left">
                                        <span>订单编号 {{order.ord.order_no}} <Icon type="ios-browsers-outline" class="cursor" @click.stop="onCopyOrderNo(order.ord.order_no)" /></span>
                                        <span>下单时间 {{order.ord.create_time}}</span>
                                        <span>买家: {{order.member.nickname || order.member.realname}}</span>
                                        <span v-if="userInfo.id !=  order.member.id" @click.stop="onChatClick(order.member)">
                                            <img src="@/assets/images/shop-manage/icon-shop-order-service.png" alt="" class="contact-icon" /> 联系买家
                                        </span>
                                    </div>
                                    <Poptip v-if="false" placement="top-end" trigger="hover" :disabled="!order.owner_memo">
                                        <template #content>
                                            <div>{{order.owner_memo}}</div>
                                        </template>
                                        <div class="top-right" @click.stop="showOrderRemark(order)">
                                            <img :src="order.owner_flag|remark_filter" alt="" class="remark-icon" /><span v-if="!order.owner_memo">添加备注</span>
                                        </div>
                                    </Poptip>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <!-- 商品信息 -->
                            <td>
                                <div class="item-product-col" >
                                    <img :src="order.goods.product_image|default_img" alt="" class="product-cover" />
                                    <div class="name-spec-box">
                                        <div class="name">{{order.goods.product_name}}</div>
                                        <div class="spec">{{order.goods.spec_info}}</div>
                                    </div>
                                </div>
                            </td>
                            <!-- 单价/数量 -->
                            <td>
                                <div class="item-price-col">
                                    <span>¥{{order.goods.price}}</span>
                                    <span>¥{{order.goods.tag_price || 0}}</span>
                                    <span>x{{order.new_spec_quantity ? order.new_spec_quantity : (order.goods ? order.goods.quantity : '-')}}</span>
                                </div>
                            </td>
                            <!-- 实收金额 -->
                            <td>
                                <div class="item-pay-price-col">
                                    <span>¥{{order.goods.money}}</span>
                                    <!-- <span>含运费</span>
                                    <span>8.00</span> -->
                                </div>
                            </td>
                            <!-- 售后状态 -->
                            <td>
                                <div class="item-after-sale-col">
                                    <!-- <template v-if="index % 2 != 0"> -->
                                        <div class="after-sale-type" :title="`售后类型:${order.type_name}`">
                                            <div class="label">售后类型:</div>
                                            <div class="value">{{order.type_name}}</div>
                                        </div>
                                        <span :title="`退货原因:${order.user_reason}`">退货原因:{{order.user_reason}}</span>
                                        <span :title="`退款金额:${order.apply_money}`">退款金额:¥{{order.apply_money}}</span>
                                        <div class="voucher-box" @click="onViewImg(order.user_proof, order.refund_no)">
                                            <img src="@/assets/images/shop-manage/icon-shop-order-voucher.png" alt="" class="voucher-icon" />
                                            查看凭证({{order.user_proof.length}}张)
                                        </div>
                                    <!-- </template>
                                    <div v-else class="empty">-</div> -->
                                </div>
                            </td>
                            <!-- 订单状态 -->
                            <td>
                                <div class="item-order-status-col">
                                    <div class="order-status">
                                        <div :class="onGetStatusClass(order.status_text)">
                                            {{ order.status_name }} <span v-if="order.delivery_mode == 0">(工厂代发)</span>
                                        </div>
                                    </div>
                                    <Poptip placement="left" trigger="hover" :disabled="!order.logistics_no">
                                        <template #content>
                                            <div class="logistics-pop">
                                                <div class="pop-title">
                                                    <div class="title-left">
                                                        <div class="company-name">顺丰速运</div>
                                                        <div class="logistics-no">运单号：SF1069888888</div>
                                                    </div>
                                                    <div class="title-more">查看更多<Icon type="ios-arrow-forward" size="12" /></div>
                                                </div>
                                                <div class="pop-content">
                                                    <div class="content-item" v-for="(item,index) in 3" :key="index">
                                                        <div class="item-time">2026-08-08 08:08:08</div>
                                                        <div class="item-content">
                                                            <div v-if="index == 0" class="content-status">运输中</div>
                                                            <div class="content-desc">
                                                                [泉州市]您的快件离开[泉州市转运中心],已发往[丰泽转运中心]。预计[08月08日]到达[软件园店],因运输距离较远,预计将在[08日晚上]为您更新快件状态,请您放心!
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <div v-if="order.logistics_no && order.status_delivery != 0" class="logistics">查询物流</div>
                                    </Poptip>
                                    <div v-if="false" class="apply-time">
                                        <span>申请时间</span>
                                        <span>2025-08-08 08:08</span>
                                    </div>
                                </div>
                            </td>
                            <!-- 操作 -->   
                            <td>
                                <div class="item-operation-col">
                                    <!-- <div class="contact-service" v-if="order.delivery_mode == 0">联系工厂客服</div> -->
                                    <template v-if="query_form.status == 'in_service'">
                                        <template v-if="order.status_text == 'create'">
                                            <div class="apply-order" @click.stop="onApplyOrder(order)">审核通过</div>
                                            <div class="reject-order" @click.stop="onRejectOrder(order)">驳回申请</div>
                                        </template>
                                        <template v-else>
                                            <div v-if="order.status_text == 'wait_shop_confirm'" class="confirm-recive" @click.stop="onReciveOrder(order)">确认收货</div>
                                            <div v-if="order.status_text == 'wait_shop_send'" class="fill-logistics-info" @click.stop="onExchangeShipped(order)">填写发货信息</div>
                                        </template>
                                        <div class="order-detail-btn" @click.stop="onServiceDetail(order)">售后详情</div>
                                    </template>
                                    <!-- <div class="order-detail-btn" @click="onDetailClick(order)">订单详情</div> -->
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </template>
                <tbody v-else-if="list.length == 0 && !is_loading">
                    <tr>
                        <td :colspan="['all','in_service'].includes(query_form.status) ? 5 : 4" style="text-align:center;">暂无数据</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td :colspan="['all','in_service'].includes(query_form.status) ? 5 : 4">
                            <Spin>
                                <Icon
                                type="ios-loading"
                                size="40"
                                class="spin-icon-load"
                                ></Icon>
                                <div>数据加载中...</div>
                            </Spin>
                        </td>
                    </tr>
                </tbody>
             </table>
             <Page :current="query_form.page" :page-size="query_form.size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  show-sizer @on-page-size-change="changeSize" :page-size-opts="[5, 10, 20]"></Page>
        </div>
        <!-- 添加备注 -->
        <portal to="global-layer">
            <order-remark v-if="show_remark" :order="curr_order" @close="onCloseRemark" @on-remarked="onGetOrderList"></order-remark>
        </portal>
        <chat ref="chat"></chat>

        <!-- 凭证预览弹窗 -->
        <portal to="global-layer">
            <div class="voucher-modal-mask" v-if="showVoucherModal" @click="onCloseVoucherModal">
                <div class="voucher-modal-content" @click.stop>
                    <div class="voucher-modal-header">
                        <span class="voucher-modal-title">凭证预览 <span v-if="voucherOrderNo" class="order-no">(售后单号:{{voucherOrderNo}})</span></span>
                        <Icon type="ios-close" size="24" class="voucher-modal-close" @click="onCloseVoucherModal" />
                    </div>
                    <div class="voucher-modal-body">
                        <div class="voucher-item" v-for="(item, index) in voucherList" :key="index">
                            <template v-if="util.test_image(item)">
                                <img :src="item" alt="凭证图片" class="voucher-img" @click="onPreviewImage(index)" />
                            </template>
                            <template v-else-if="util.is_video(item)">
                                <!-- 检测中 -->
                                <div v-if="voucherProbeStatus[index] === undefined" class="voucher-video-wrapper voucher-video-loading">
                                    <div class="video-loading-spinner"></div>
                                    <span class="video-detect-text">视频文件检测中...</span>
                                </div>
                                <!-- 可播放 -->
                                <div v-else-if="voucherProbeStatus[index] === true" class="voucher-video-wrapper" @click.stop="onPreviewVideo(item)">
                                    <img 
                                        :src="item + '?x-oss-process=video/snapshot,t_1000,f_jpg,m_fast,ar_auto'" 
                                        class="voucher-video-cover" 
                                        @error="e => e.target.style.display='none'"
                                    />
                                    <div class="video-play-overlay">
                                        <svg viewBox="0 0 24 24" fill="white" width="48" height="48">
                                            <path d="M8 5v14l11-7z"/>
                                        </svg>
                                    </div>
                                </div>
                                <!-- 不可播放 -->
                                <div v-else class="voucher-video-wrapper voucher-video-downloaded" @click.stop="onDownloadVideo(item)">
                                    <img 
                                        :src="item + '?x-oss-process=video/snapshot,t_1000,f_jpg,m_fast,ar_auto'" 
                                        class="voucher-video-cover voucher-video-cover-dimmed" 
                                        @error="e => e.target.style.display='none'"
                                    />
                                    <div class="video-downloaded-overlay">
                                        <span class="download-hint">该视频只支持下载查看</span>
                                        <span class="download-click">点击下载</span>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </portal>
        <replenish-order ref="replenishOrder" />
    </div>
</template>
<script>
import { shopOrderList, shopOrderListCount, shopServiceOrderList, shopStatistics } from '@/api/index';
import util from '@/utils/util.js';
import { mapState } from 'vuex';
import OrderRemark from './OrderRemark.vue';
import ReplenishOrder from './ReplenishOrder.vue';
export default{
    name:"OrderManage",
    components:{
        OrderRemark,
        ReplenishOrder
    },
    data(){
        return{
            util,
            showVoucherModal: false,
            voucherList: [],
            voucherOrderNo: '',
            currentVoucherIndex: 0,
            tab_list:[
                {name:'全部',value:'all',count:0},
                {name:'待付款',value:'wait_pay',count:0},
                {name:'待发货',value:'wait_delivery',count:0},
                {name:'待收货',value:'wait_confirm',count:0},
                {name:'售后中',value:'in_service',count:0},
                {name:'已完成',value:'complete',count:0},
                {name:'已关闭',value:'close',count:0}
            ],
            query_form:{
                status:'all',
                keyword:'',
                page:1,
                size:15
            },
            list:[],
            show_remark:false,
            total:0,
            curr_order:{},
            is_loading:true,
            statistics:{},
            stat_status:'today',
            voucherProbeStatus:{}
        }
    },
    filters:{
        remark_filter(value){
            switch(value){
                case 'green':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-green.png');
                case 'blue':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-blue.png');
                case 'red':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-red.png');
                case 'yellow':
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-yellow.png');
                default:
                    return require('@/assets/images/shop-manage/icon-shop-order-remark-empty.png');
            }
        },
    },
    computed:{
        ...mapState({
            shopInfo:state=>state.shopInfo,
            userInfo:state=>state.userInfo
        })
    },
    mounted(){
        console.log('aaa-order-manage-mounted');
        this.$store.dispatch('getUser');
        this.onGetOrderList();
        this.onGetStatistics();
        this.$bus.$on('list-refresh',()=>{
            this.onListRefresh();
            this.onGetStatistics();
        });
    },
    beforeDestroy(){
        this.$bus.$off('list-refresh');
    },
    methods:{
        onChatClick(user){
            this.$refs["chat"].showChat(null, user);
        },
        onServiceDetail(order){
            console.log('order',order);
            this.$emit('service-detail',order);
        },
        onGoShop(){
            // this.$router.push({name:'ShopHome',query: { uid: this.userInfo.code }});
            //>新标签页打开,使用router.resolve
            const route = this.$router.resolve({name:'ShopHome',query: { uid: this.userInfo.code }});
            window.open(route.href,'_blank');
        },
        onShowAssetCenter(){
            this.$emit('show-asset-center');
        },
        async onChangeStatFilter(type){
            this.stat_status = type;
            this.onGetStatistics()
        },
        async onGetStatistics(){
            try{
                const param ={};
                param.range = this.stat_status;
                const {code,msg,data} = await shopStatistics(param);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-statistics',data);
                this.statistics = data;
            }catch(e){
                console.log('err-statistics',e);
                this.$layer.msg(e.msg);
            }
        },
        onListRefresh(){
            if(this.query_form.status === 'in_service'){
                this.onGetServiceOrderList();
            }else{
                this.onGetOrderList();
            }
        },
        onViewImg(imgs, orderNo){
            if(!imgs || imgs.length === 0){
                this.$layer.msg('暂无凭证上传');
                return;
            }
            this.voucherList = imgs;
            this.voucherOrderNo = orderNo || '';
            this.voucherProbeStatus = {};
            this.showVoucherModal = true;
            // 探测所有视频文件的编码
            imgs.forEach((item, index) => {
                const url = typeof item === 'object' ? item.url : item;
                if (!this.util.is_video(url)) return;
                this.$set(this.voucherProbeStatus, index, undefined);
                this.util.probeVideoPlayable(url).then((playable) => {
                    this.$set(this.voucherProbeStatus, index, playable);
                });
            });
        },
        onDownloadVideo(url){
            this.util.downloadVideo(url);
        },
        onCloseVoucherModal(){
            this.showVoucherModal = false;
            this.voucherProbeStatus = {};
        },
        onPreviewImage(index){
            // 过滤出纯图片列表用于预览
            const imageList = this.voucherList.filter(item => this.util.test_image(item));
            // 找到当前图片在纯图片列表中的索引
            const currentIndex = imageList.indexOf(this.voucherList[index]);
            this.$viewerApi({
                images: imageList,
                options: { initialViewIndex: currentIndex >= 0 ? currentIndex : 0 }
            });
        },
        async onPreviewVideo(url){
            const playable = await this.util.probeVideoPlayable(url);
            if(!playable){
                this.util.downloadVideo(url);
                return;
            }
            const mask = document.createElement('div');
            mask.className = 'video-preview-mask';
            mask.onclick = (e) => {
                if(e.target === mask) mask.remove();
            };
            mask.innerHTML = `
                <div class="video-preview-container" onclick="event.stopPropagation()">
                    <div class="video-preview-close" onclick="event.stopPropagation(); this.closest('.video-preview-mask').remove()">×</div>
                    <video src="${url}" controls autoplay class="video-preview"></video>
                </div>
            `;
            document.body.appendChild(mask);
        },
        onCopyOrderNo(order_no){
            navigator.clipboard.writeText(order_no).then(()=>{
                this.$layer.msg('复制成功~');
            }).catch(e=>{
                console.log('err-cp',e);
                this.$layer.msg('复制失败~');
            });
        },
        onChangeStatus({value}){
            this.query_form.status = value;
            if(value === 'in_service'){
                this.onGetServiceOrderList();
            }else{
                this.onGetOrderList();
            }
        },
        showOrderRemark(order){
            // const {owner_memo} = order;
            // if(owner_memo) return;
            this.curr_order = order;
            this.show_remark = true;
        },
        async onGetListCount(){
            try{
                const {code,msg,data} = await shopOrderListCount(this.query_form);
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data',data);
                this.tab_list = this.tab_list.map((item)=>{
                    // console.log(data[item.value]);
                    if(data[item.value]){
                        return {...item,count:data[item.value] || 0}
                    }else{
                        return {...item,count:0};
                    }
                })
            }catch(e){
                console.log(' err-on-get-list-count',e);
                this.$layer.msg(e.msg);
            }
        },
        changePage(page) {
				this.query_form.page = page
				if(this.query_form.status === 'in_service'){
					this.onGetServiceOrderList();
				}else{
					this.onGetOrderList();
				}
        },
        changeSize(size) {
            this.query_form.page = 1
            this.query_form.size = size
            if(this.query_form.status === 'in_service'){
				this.onGetServiceOrderList();
			}else{
				this.onGetOrderList();
			}
        },
        onExchangeShipped(order){
            console.log('order-exchange-shipped',order);
            this.$emit('exchange-shipped',order);
        },
        onReciveOrder(order){ 
            console.log('order-recive',order);
            this.$emit('recive-order',order);
        },
        onRejectOrder(order){ 
            console.log('order-reject',order);
            if([1,3].includes(Number(order.type))){
                //>拒绝退货
                this.$emit('reject-order',order);
            }else{
                //>拒绝换货
                this.$emit('reject-exchange',order);
            }
        },
        onApplyOrder(order){
            console.log('order-apply',order);
            console.log('order-type',order.type);
            if([1,3].includes(Number(order.type))){
                //>退货
                this.$emit('apply-order',order);
            }else{
                //>换货
                this.$emit('apply-exchange',order);
            }
        },
        onOrderShipped(order){
            this.$emit('shipped',order);
        },
        onDetailClick(order){
            this.$emit('detail',order);
        },
        //> 补货:有关联款式走弹窗大货阶梯下单,否则跳款式设计并带入商品封面与款式分类(父级+子级)
        onRestock(item){
            const p = (item && item.product) || {};
            const design_id = Number(p.design_id) || 0;
            if(design_id > 0){
                const design_uuid = (p.design && p.design.uuid) || '';
                if(!design_uuid){
                    this.$layer.msg('未找到关联款式，无法下大货');
                    return;
                }
                this.$refs.replenishOrder.show(p);
                return;
            }
            this.$router.push({
                name:'WorkBenchDesign',
                query:{
                    from:'restock',
                    cover:item.product_image,
                    parent_product_category_id:p.parent_product_category_id,
                    child_product_category_id:p.child_product_category_id,
                },
            });
        },
        onCloseRemark(){
            console.log('aaaaa');
            this.show_remark=false;
        },
        onGetStatusClass(val){
            switch(val){
                case 'complete':
                    return 'finish';
                case 5:
                    return 'exchange';
                case 'wait_confirm':
                    return 'wait-recive';
                case 'wait_delivery':
                case 'in_service':
                // case 4:
                    return 'wait-send';
                default:
                    return 'not-pay';
            }
        },
        onSearchOrder(){
            console.log('aaa-order-manage-onSearchOrder');
            this.query_form.page = 1;
            if(this.query_form.status === 'in_service'){
				this.onGetServiceOrderList();
			}else{
				this.onGetOrderList();
			}
        },
        async onGetServiceOrderList(){
            try{
                this.is_loading = true;
                this.list = [];
                this.onGetListCount();
                this.query_form.in_service = true;
                const {code,msg,data} = await shopServiceOrderList(this.query_form);
                if(code>0){
                    this.$layer.msg(msg);
                    this.is_loading = false;
                    return;
                }
                this.list = data.list;
                this.total = data.total;
                this.is_loading = false;
            }catch(e){
                console.log('err-service-list',e);
                this.is_loading = false;
            }
        },
        async onGetOrderList(){
            try{
                this.is_loading = true;
                this.list = [];
                this.onGetListCount();
                const {code,msg,data} = await shopOrderList(this.query_form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                console.log('data-list',data);
                this.list = data.list;
                this.total = data.total;
                this.is_loading = false;
            }catch(e){
                console.log('err-get-order-list',e);
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.order-manage{
    width:100%;
    display:flex;
    flex-direction:column;
    row-gap:19px;
    user-select: none;
    .top{
        display:flex;
        align-items:center;
        column-gap:20px;
        .operating-data{
            flex:1;
            max-width:1198px;
            border-radius:10px;
            background:#ffffff;
            flex-shrink:0;
            padding:20px 30px 24px 30px;
            display:flex;
            flex-direction:column;
            row-gap:20px;
            .title-box{
                width:100%;
                align-items:center;
                justify-content:space-between;
                display:flex;
                .title{
                    color:#1a1a1a;
                    font-size:18px;
                    font-weight:400;
                }
                .filter-box{
                    display:flex;
                    align-items:center;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    .filter-item{
                        padding:8px 20px;
                        color:#666666;
                        font-size:12px;
                        font-weight:400;
                        cursor:pointer;
                        &:nth-child(2){
                            border-right:1px solid #e3e3e3;
                            border-left:1px solid #e3e3e3;
                        }
                        &:nth-child(3){
                            border-right:1px solid #e3e3e3;
                        }
                        &:hover,&.active{
                            color:#0d99ff;
                        }
                    }
                }
            }
            .data-box{
                width:100%;
                display:flex;
                column-gap:20px;
                .today-box{
                    flex:1;
                    max-width:410px;
                    flex-shrink:0;
                    background:#f7faff;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    .line{
                        width:1px;
                        height:76px;
                        background:#e8ebf0;
                    }
                    .today-data-items{
                        flex:0 0 calc(50% - 1px);
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        justify-content:center;
                        padding:17px 0 15px 0;
                        .item-title{
                            color:#666666;
                            font-size:14px;
                            font-weight:400;
                            margin-bottom:11px;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                        .item-count{
                            color:#1a1a1a;
                            font-size:24px;
                            font-weight:700;
                            margin-bottom:5px;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                        .item-desc{
                            color:#666666;
                            font-size:12px;
                            font-weight:400;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                    }
                }
                .order-count-box{
                    flex:1;
                    max-width:446px;
                    background:#f7faff;
                    display:flex;
                    align-items:center;
                    justify-content:space-between;
                    .order-count-item{
                        display:flex;
                        flex:1;
                        flex-shrink:0;
                        flex-direction:column;
                        align-items:center;
                        justify-content:center;
                        row-gap:11px;
                        padding:17px 0 15px 0;
                        .item-title{
                            color:#666666;
                            font-size:14px;
                            font-weight:400;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                        .item-count{
                            color:#1a1a1a;
                            font-size:24px;
                            font-weight:700;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                    }
                }
            }
            .month-sale-count{
                flex:1;
                max-width:242px;
                background:#f7faff;
                display:flex;
                flex-direction:column;
                align-items:center;
                justify-content:center;
                padding:17px 0 15px 0;
                .item-title{
                    color:#666666;
                    font-size:14px;
                    font-weight:400;
                    margin-bottom:11px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                .item-count{
                    color:#1a1a1a;
                    font-size:24px;
                    font-weight:700;
                    margin-bottom:7px;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
                .item-desc{
                    color:#666666;
                    font-size:12px;
                    font-weight:400;
                    white-space:nowrap;
                    overflow:hidden;
                    text-overflow:ellipsis;
                }
            }
        }
        .shop-info{
            width:358px;
            flex-shrink:0;
            background:#ffffff;
            border-radius:10px;
            display:flex;
            flex-direction:column;
            padding:20px;
            .shop-owner-info{
                width:100%;
                display:flex;
                justify-content:space-between;
                column-gap:24px;
                .info{
                    flex:0 0 calc(100% - 128px);
                    display:flex;
                    column-gap:12px;
                    .user-avatar{
                        width:48px;
                        height:48px;
                        border-radius:4px;
                        object-fit:cover;
                    }
                    .name-desc{
                        display:flex;
                        flex-direction:column;
                        row-gap:9px;
                        width:100%;
                        max-width:174px;
                        .shop-name{
                            color:#333333;
                            font-size:14px;
                            font-weight:400px;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                        .shop-desc{
                            width:100%;
                            color:#666666;
                            font-size:12px;
                            font-weight:400;
                            white-space:nowrap;
                            overflow:hidden;
                            text-overflow:ellipsis;
                        }
                    }
                }
                .enter-shop{
                    width:64px;
                    height:24px;
                    line-height:24px;
                    flex-shrink:0;
                    border-radius:4px;
                    border:1px solid #e3e3e3;
                    text-align:center;
                    color:#666666;
                    font-size:12px;
                    font-weight:400;
                    cursor:pointer;
                }
            }
            .balance-count{
                width:100%;
                display:flex;
                align-items:center;
                justify-content:space-between;
                margin-top:25px;
                .count-item{
                    display:flex;
                    flex-direction:column;
                    row-gap:7px;
                    padding:0 20px;
                    text-align:center;
                    .item-title{
                        color:#666666;
                        font-size:14px;
                        white-space:nowrap;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                    }
                    .item-count{
                        color:#1a1a1a;
                        font-size:18px;
                        font-weight:700;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow:ellipsis;
                    }
                    &:first-child{
                        padding-left:0 !important;
                    }
                    &:nth-child(2){
                        padding-left:0 !important;
                    }
                    &:last-child{
                        border-left:1px solid #ebebeb;
                    }
                }
            }
            .withdrawal-btn{
                width:100%;
                height:32px;
                line-height:32px;
                text-align:center;
                border:1px solid #e3e3e3;
                border-radius:4px;
                cursor:pointer;
                margin-top:18px;
            }
        }
    }
    .order-list{
        width:100%;
        background:#ffffff;
        padding:20px 30px 30px 30px;
        .order-list-top{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:space-between;
            padding-bottom:10px;
            border-bottom:1px solid #d6d6d6;
            .order-list-title{
                color:#1a1a1a;
                font-size:18px;
            }
            .order-list-search{
                width:280px;
                height:42px;
                padding:0 18px;
                background:#f3f4f6;
                border-radius:24px;
                display:flex;
                align-items:center;
                column-gap:10px;
                input{
                    outline:none;
                    border:none;
                    background:transparent;
                    flex:1;
                }
                .search-icon{
                    width:22px;
                    height:22px;
                }
            }
        }
        .order-filter-box{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:space-between;
            margin-top:25px;
            .status-filter-box{
                display:flex;
                align-items:center;
                column-gap:50px;
                .status-item{
                    cursor:pointer;
                    color:#666666;
                    font-size:16px;
                    &:hover, &.active{
                        color:#1a1a1a;
                        font-weight:bold;
                    }
                }
            }
            .time-filter{
                color:#666666;
                font-size:14px;
            }
        }
        table{
            width:100%;
            display:table;
            border-collapse:collapse;
            margin-top:25px;
            table-layout: fixed;
            padding-bottom:30px;
            thead{
                tr{
                    width:100%;
                    height:52px;
                    background:#f6f7fa;
                    th{
                        color:#666666;
                        text-align:center;
                        width:10%;
                        &:first-child{
                            width:40%;
                        }
                    }
                }
            }
            tbody{
                border-radius:10px;
                &:first-of-type::before{
                    content:"";
                    display:table-row;
                    height:20px;
                }

                &:not(:first-of-type)::before{
                    content:"";
                    display: table-row;
                    height:20px;
                }

                tr{
                    &:last-child{
                        border-bottom:1px solid #f6f7fa;
                    }
                    &:first-child{
                        td{
                           &:last-child{
                            border:none !important;
                           }
                           &:first-child{
                            border-left:none !important;
                           }
                        }
                    }
                    td{
                        &:first-child{
                            border-left:1px solid #f6f7fa;
                        }
                        &:last-child{
                            border-right:1px solid #f6f7fa;
                        }
                        .item-top{
                            width:100%;
                            height:52px;
                            padding:0 20px;
                            border-radius:9px 9px 0 0;
                            background:#f6f7fa;
                            color:#666666;
                            display:flex;
                            align-items:center;
                            justify-content:space-between;
                            font-size:13px;
                            .top-left{
                                display:flex;
                                align-items:center;
                                height:100%;
                                column-gap:32px;
                                span:last-child{
                                    display:flex;
                                    align-items:center;
                                    column-gap:8px;
                                    cursor:pointer;
                                    .contact-icon{
                                        width:22px;
                                        height:22px;
                                    }
                                }
                            }
                            .top-right{
                                display:flex;
                                align-items:center;
                                column-gap:8px;
                                color:#666666;
                                font-size:13px;
                                cursor:pointer;
                                .remark-icon{
                                    width:22px;
                                    height:22px;
                                }
                            }
                        }
                        .item-product-col{
                            // flex:0 0 40%;
                            width:100%;
                            display:flex;
                            column-gap:16px;
                            padding:20px;
                            overflow:hidden;
                            .product-cover{
                                width:96px;
                                height:96px;
                                border-radius:8px;
                                object-fit:cover;
                            }
                            .name-spec-box{
                                flex:0 0 calc(100% - 20px - 96px - 16px);
                                display:flex;
                                flex-direction:column;
                                row-gap:11px;
                                margin-top:9px;
                                .name{
                                    width:100%;
                                    white-space:nowrap;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                    color:#333333;
                                    font-size:14px;
                                }
                                .spec{
                                    color:#666666;
                                    font-size:14px;
                                    white-space:nowrap;
                                    overflow:hidden;
                                    text-overflow:ellipsis;
                                }
                                .restock-btn{
                                    align-self:flex-start;
                                    height:28px;
                                    line-height:28px;
                                    padding:0 12px;
                                    font-size:14px;
                                    color:#ffffff;
                                    background:#ff5967;
                                    border-radius:4px;
                                    cursor:pointer;
                                }
                            }
                        }
                        .item-price-col{
                            flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            align-items:center;
                            span{
                                color:#808080;
                                &:first-child{
                                    color:#333333;
                                    font-size:14px;
                                }
                                &:nth-child(2){
                                    font-size:12px;
                                    text-decoration: line-through;
                                }
                                &:last-child{
                                    font-size:13px;
                                    text-decoration:none;
                                }
                            }
                        }
                        .item-pay-price-col{
                            flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            align-items:center;
                            span{
                                color:#808080;
                                font-size:12px;
                                &:first-child{
                                    color:#333333;
                                    font-size:14px;
                                    font-weight:bold;
                                }
                            }
                        }
                        .item-after-sale-col{
                            // flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            // align-items:center;
                            justify-content:center;
                            .empty{
                                width:100%;
                                text-align:center;
                            }
                            .after-sale-type{
                                width:100%;
                                display:flex;
                                align-items:center;
                                font-size:14px;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                .label{
                                    color:#666666;
                                }
                                .value{
                                    color:#ff0016;
                                }
                            }
                            span{
                                font-size:12px;
                                color:#666666;
                                white-space:nowrap;
                                overflow:hidden;
                                text-overflow:ellipsis;
                                text-align:left;
                            }
                            .voucher-box{
                                display:flex;
                                align-items:center;
                                column-gap:6px;
                                color:#0d99ff;
                                font-size:12px;
                                cursor:pointer;
                                .voucher-icon{
                                    width:20px;
                                    height:20px;
                                }
                            }
                        }
                        .item-order-status-col{
                            flex:0 0 10%;
                            display:flex;
                            flex-direction:column;
                            align-items:center;
                            justify-content:center;
                            .order-status{
                                font-size:14px;
                                color:#999999;
                                white-space:nowrap;
                                text-overflow:ellipsis;
                                overflow:hidden;
                                .finish{
                                    color:#666666;
                                }
                                .exchange{
                                    color:#0d99ff;
                                }
                                .wait-send,.check,.exchange-not-back{
                                    color:#ff5000;
                                }
                                .wait-recive{
                                    color:#02c160;
                                }
                                .not-pay{
                                    color:#333333;
                                }
                            }
                            .logistics-pop{
                                width:534px;
                                background:#fff;
                                display:flex;
                                flex-direction:column;
                                .pop-title{
                                    width:100%;
                                    display:flex;
                                    align-items:center;
                                    justify-content:space-between;
                                    padding-bottom:10px;
                                    border-bottom:1px solid #e3e3e3;
                                    margin-top:17px;
                                    .title-left{
                                        display:flex;
                                        column-gap:16px;
                                        .company-name{
                                            font-size:12px;
                                            font-weight:bold;
                                            color:#333;
                                        }
                                        .logistics-no{
                                            color:#333;
                                            font-size:12px;
                                            font-weight:bold;
                                        }
                                    }
                                    .title-more{
                                        display:flex;
                                        align-items:center;
                                        color:#666;
                                        font-size:12px;
                                        cursor:pointer;
                                    }
                                }
                                .pop-content{
                                    width:100%;
                                    margin-top:17px;
                                    display:flex;
                                    flex-direction:column;

                                    .content-item{
                                        display:flex;
                                        align-items:flex-start;
                                        column-gap:26px;
                                        .item-time{
                                            width:62px;
                                            white-space:wrap;
                                            flex-shrink:0;
                                            text-align:right;
                                        }
                                        .item-content{
                                            flex:1;
                                            display:flex;
                                            flex-direction:column;
                                            padding-left:26px;
                                            overflow-y:hidden;
                                            overflow-x:visible;
                                            .content-status{
                                                color:#333;
                                                font-size:14px;
                                                font-weight:bold;
                                            }
                                            .content-desc{
                                                padding-bottom:12px;
                                                color:#333;
                                                font-size:12px;
                                                width:100%;
                                                white-space:wrap;
                                            }

                                            position:relative;
                                            &::after{
                                                content:'';
                                                border-left:1px solid #e3e3e3;
                                                padding-left:26px;
                                                position:absolute;
                                                height:100%;
                                                left:0;
                                                top:30%;
                                            }
                                        }
                                        &:nth-child(2){
                                            .item-content{
                                                overflow:visible;
                                                &::after{
                                                    content:'';
                                                    border-left:1px solid #e3e3e3;
                                                    padding-left:26px;
                                                    position:absolute;
                                                    height:80%;
                                                    left:0;
                                                    top:15px;
                                                }
                                                &::before{
                                                    content:'';
                                                    position:absolute;
                                                    left:-3px;
                                                    top:4px;
                                                    width:7px;
                                                    height:7px;
                                                    border-radius:50%;
                                                    background:#e3e3e3;
                                                    z-index:2;
                                                }
                                            }
                                        }
                                        &:nth-child(3){
                                            .item-content{
                                                overflow:visible;
                                                &::after{
                                                    content:'';
                                                    border-left:1px solid #e3e3e3;
                                                    padding-left:26px;
                                                    position:absolute;
                                                    height:70%;
                                                    left:0;
                                                    top:15px;
                                                }
                                                &::before{
                                                    content:'';
                                                    position:absolute;
                                                    left:-3px;
                                                    top:5px;
                                                    width:7px;
                                                    height:7px;
                                                    border-radius:50%;
                                                    background:#e3e3e3;
                                                    z-index:2;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                            .logistics{
                                display:flex;
                                align-items:center;
                                column-gap:8px;
                                color:#333333;
                                font-size:14px;
                                cursor:pointer;
                                &::after{
                                    content:"";
                                    background:#ff5967;
                                    width:6px;
                                    height:6px;
                                    border-radius:50%;
                                }
                            }
                            .apply-time{
                                display:flex;
                                flex-direction: column;
                                align-items: center;
                                color:#666666;
                                font-size:12px;
                            }
                        }
                        .item-operation-col{
                            display:flex;
                            flex-direction:column;
                            row-gap:8px;
                            align-items:center;
                            justify-content:center;
                            height:100%;
                            .order-detail-btn{
                                color:#333333;
                                font-size:14px;
                                cursor:pointer;
                            }
                            .order-send,
                            .contact-service,
                            .reject-order,
                            .confirm-recive,
                            .fill-logistics-info,
                            .apply-order{
                                height:28px;
                                font-size:14px;
                                border-radius:4px;
                                color:#ffffff;
                                text-align:center;
                                line-height:28px;
                                padding:0 8px;
                                cursor:pointer;
                            }
                            .order-send,
                            .contact-service,
                            .reject-order,
                            .confirm-recive,
                            .fill-logistics-info{
                                background:#ff5967;
                            }
                            .apply-order{
                                background:#02c160;
                            }
                            .order-send{
                                width:72px;
                            }
                        }
                    }
                }
            }
        }
    }
}
// 针对桌面端大屏 (1280px - 1679px)
@media screen and (min-width: 1280px) and (max-width: 1679px) {
  .order-manage {
    // 使用 transform 进行整体缩放
    transform: scale(0.9); // 缩放到 90%
    transform-origin: top left; // 设置缩放原点为左上角
    width: calc(100% / 0.9); // 调整容器宽度以补偿缩放带来的空白
    height: calc(100% / 0.9); // 调整容器高度以补偿缩放带来的空白

    // 其他样式保持默认不变
    .top {
      .operating-data {
        max-width: 1198px; // 保持默认最大宽度
      }

      .shop-info {
        width: 358px; // 保持默认宽度
      }
    }

    .order-list {
      .order-list-search {
        width: 280px; // 保持默认宽度
      }
    }
  }
}

// 针对小屏设备 (最大1279px)，保持原有布局不变，只做缩放调整
@media screen and (max-width: 1279px) {
  .order-manage {
    row-gap: 15px; // 减小整体行间距
    
    .top {
      column-gap: 15px; // 减小顶部两列间距
      
      .operating-data {
        padding: 15px 20px 18px 20px; // 调整内边距
        max-width: calc(100% - 280px); // 调整最大宽度以适应小屏
        
        .title-box {
          .title {
            font-size: 16px; // 减小标题字体
          }
          
          .filter-box {
            .filter-item {
              padding: 6px 12px; // 减小筛选项内边距
              font-size: 11px; // 减小字体大小
            }
          }
        }
        
        .data-box {
          column-gap: 15px; // 减小数据区域列间距
          
          .today-box {
            max-width: 320px; // 调整今日数据区域宽度
            .line {
              height: 60px; // 调整分割线高度
            }
            .today-data-items {
              padding: 12px 0 10px 0; // 调整内边距
              .item-title {
                font-size: 12px; // 减小标题字体
              }
              .item-count {
                font-size: 20px; // 减小数字大小
              }
              .item-desc {
                font-size: 11px; // 减小描述字体
              }
            }
          }
          
          .order-count-box {
            max-width: 320px; // 调整订单统计区域宽度
            .order-count-item {
              row-gap: 8px; // 减小间距
              .item-title {
                font-size: 12px; // 减小标题字体
              }
              .item-count {
                font-size: 20px; // 减小数字大小
              }
            }
          }
        }
        
        .month-sale-count {
          max-width: 180px; // 调整月销售额区域宽度
          .item-title {
            font-size: 12px; // 减小标题字体
          }
          .item-count {
            font-size: 20px; // 减小数字大小
          }
          .item-desc {
            font-size: 11px; // 减小描述字体
          }
        }
      }
      
      .shop-info {
        width: 280px; // 调整店铺信息区域宽度
        padding: 15px; // 调整内边距
        
        .shop-owner-info {
          column-gap: 15px; // 减小间距
          
          .info {
            column-gap: 8px; // 减小间距
            .user-avatar {
              width: 40px; // 减小头像尺寸
              height: 40px;
            }
            .name-desc {
              .shop-name {
                font-size: 13px; // 减小字体
              }
              .shop-desc {
                font-size: 11px; // 减小字体
              }
            }
          }
          
          .enter-shop {
            width: 56px; // 调整按钮宽度
            height: 22px;
            line-height: 22px;
            font-size: 11px;
          }
        }
        
        .balance-count {
          margin-top: 20px; // 调整间距
          .count-item {
            &:first-child {
              padding-left: 0; // 保持原有样式
            }
            .item-title {
              font-size: 12px; // 减小字体
            }
            .item-count {
              font-size: 16px; // 减小数字大小
            }
          }
        }
        
        .withdrawal-btn {
          height: 28px;
          line-height: 28px;
          margin-top: 15px;
        }
      }
    }
    
    .order-list {
      padding: 15px 20px 20px 20px; // 调整内边距
      
      .order-list-top {
        .order-list-title {
          font-size: 16px; // 减小标题字体
        }
        
        .order-list-search {
          width: 220px; // 调整搜索框宽度
          height: 36px; // 调整高度
          padding: 0 12px; // 调整内边距
          .search-icon {
            width: 18px; // 减小图标尺寸
            height: 18px;
          }
        }
      }
      
      .order-filter-box {
        margin-top: 20px; // 调整间距
        
        .status-filter-box {
          column-gap: 30px; // 调整状态筛选间距
          .status-item {
            font-size: 14px; // 减小字体
          }
        }
        
        .time-filter {
          font-size: 12px; // 减小字体
        }
      }
      
      table {
        margin-top: 20px; // 调整间距
        
        thead {
          tr {
            height: 42px; // 调整表头高度
            th {
              font-size: 12px; // 减小字体
            }
          }
        }
        
        tbody {
          &:first-of-type::before,
          &:not(:first-of-type)::before {
            height: 15px; // 调整间距
          }
          
          tr {
            td {
              .item-top {
                height: 42px; // 调整顶部高度
                padding: 0 15px; // 调整内边距
                font-size: 12px; // 减小字体
                .top-left {
                  column-gap: 20px; // 调整间距
                  span:last-child {
                    .contact-icon {
                      width: 18px; // 减小图标尺寸
                      height: 18px;
                    }
                  }
                }
                .top-right {
                  column-gap: 6px; // 调整间距
                  font-size: 12px; // 减小字体
                  .remark-icon {
                    width: 18px; // 减小图标尺寸
                    height: 18px;
                  }
                }
              }
              
              .item-product-col {
                padding: 15px; // 调整内边距
                .product-cover {
                  width: 80px; // 减小商品图尺寸
                  height: 80px;
                }
                .name-spec-box {
                  row-gap: 8px; // 调整间距
                  margin-top: 6px; // 调整间距
                  .name,
                  .spec {
                    font-size: 12px; // 减小字体
                  }
                }
              }
              
              .item-price-col {
                span {
                  &:first-child {
                    font-size: 12px; // 减小字体
                  }
                  &:nth-child(2) {
                    font-size: 11px; // 减小字体
                  }
                  &:last-child {
                    font-size: 12px; // 减小字体
                  }
                }
              }
              
              .item-pay-price-col {
                span {
                  &:first-child {
                    font-size: 12px; // 减小字体
                  }
                }
              }
              
              .item-after-sale-col {
                .after-sale-type {
                  font-size: 12px; // 减小字体
                }
                span {
                  font-size: 11px; // 减小字体
                }
                .voucher-box {
                  .voucher-icon {
                    width: 16px; // 减小图标尺寸
                    height: 16px;
                  }
                }
              }
              
              .item-order-status-col {
                .order-status {
                  font-size: 12px; // 减小字体
                }
                
                .logistics-pop {
                  width: 400px; // 调整弹窗宽度
                }
                
                .logistics {
                  font-size: 12px; // 减小字体
                }
                
                .apply-time {
                  font-size: 11px; // 减小字体
                }
              }
              
              .item-operation-col {
                row-gap: 6px; // 减小间距
                
                .order-detail-btn {
                  font-size: 12px; // 减小字体
                }
                
                .order-send,
                .contact-service,
                .reject-order,
                .confirm-recive,
                .fill-logistics-info,
                .apply-order {
                  height: 24px; // 调整按钮高度
                  font-size: 12px; // 减小字体
                  line-height: 24px; // 调整行高
                }
                
                .order-send {
                  width: 60px; // 调整宽度
                }
              }
            }
          }
        }
      }
    }
  }
}

.spin-icon-load {
    animation: ani-spin 1s linear infinite;
}
@keyframes ani-spin {
    from {
        transform: rotate(0deg);
    }
    50% {
        transform: rotate(180deg);
    }
    to {
        transform: rotate(360deg);
    }
}

/* 凭证预览弹窗 */
.voucher-modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}

.voucher-modal-content {
    background: #fff;
    border-radius: 8px;
    width: 700px;
    max-width: 90vw;
    max-height: 80vh;
    display: flex;
    flex-direction: column;
}

.voucher-modal-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid #e8e8e8;
}

.voucher-modal-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
}

.voucher-modal-title .order-no {
    font-weight: 400;
    color: #999;
    font-size: 14px;
}

.voucher-modal-close {
    cursor: pointer;
    font-size: 24px;
    color: #999;
    transition: color 0.2s;
}

.voucher-modal-close:hover {
    color: #333;
}

.voucher-modal-body {
    padding: 20px;
    overflow-y: auto;
    max-height: calc(80vh - 60px);
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}

.voucher-item {
    position: relative;
    width: 180px;
    height: 180px;
    border-radius: 6px;
    overflow: hidden;
    border: 1px solid #e8e8e8;
}

.voucher-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
    transition: transform 0.2s;
}

.voucher-img:hover {
    transform: scale(1.03);
}

.voucher-video-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
}

.voucher-video-cover {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.video-play-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: background 0.2s;
}

.video-play-overlay:hover {
    background: rgba(0, 0, 0, 0.5);
}

/* 视频检测态 */
.voucher-video-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #f5f5f5;
    gap: 12px;
    .video-loading-spinner {
        width: 32px;
        height: 32px;
        border: 3px solid #e0e0e0;
        border-top-color: #0d99ff;
        border-radius: 50%;
        animation: voucher-spin 0.8s linear infinite;
    }
    .video-detect-text {
        color: #999;
        font-size: 13px;
    }
}
@keyframes voucher-spin {
    to { transform: rotate(360deg); }
}

/* 视频已下载态 */
.voucher-video-downloaded {
    cursor: pointer;
    .voucher-video-cover-dimmed {
        filter: brightness(0.5);
    }
    .video-downloaded-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        .download-hint {
            color: #fff;
            font-size: 13px;
            opacity: 0.9;
        }
        .download-click {
            color: #0d99ff;
            font-size: 13px;
            font-weight: 500;
        }
    }
    &:hover .video-downloaded-overlay .download-click {
        text-decoration: underline;
    }
}

/* 视频全屏预览 */
.video-preview-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.85);
    z-index: 10000;
    display: flex;
    align-items: center;
    justify-content: center;
}

.video-preview-container {
    position: relative;
    width: 80vw;
    max-width: 900px;
}

.video-preview {
    width: 100%;
    max-height: 80vh;
    border-radius: 4px;
}

.video-preview-close {
    position: absolute;
    top: -36px;
    right: 0;
    color: #fff;
    font-size: 28px;
    cursor: pointer;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    transition: background 0.2s;
}

.video-preview-close:hover {
    background: rgba(255, 255, 255, 0.2);
}
</style>